// extracted by mini-css-extract-plugin
export default {"card":"EataSection_card__gJ1w7"};